import React from 'react';
import './Section2.css';

function Section2() {
  const handleClick = () => {
    window.open("https://donor.southtexasblood.org/donor/store/preview?utm_source=double_my_impact&utm_medium=landing_page&utm_campaign=twa_dontate&utm_content=stb&t",
     "_blan");
  };
  return (
    <div className="camp-container">
        <div className="camp-title">Help us Reach Our Goal</div>
        <div className="goal-1">In partnership with the <span className="bold-t">San Antonio MOW</span>, we want 
        to raise funds to support the effort of feeding our elderly.</div>
        <div className="progress"></div>
        <div className="goal-2">50 MEALS FOR SENIORS PER DAY IN MARCH</div>
        



          <div className="flex-container">
           <div className="left-content">
             <div className="q1">How do I Donate?</div>
             <div className="a1">Donating is easy.  Log into the South Texas 
             Blood and Tissue online store and select the Double Your 
             Impact Meals on Wheels icon to donate a 100 points.  
             You can donate as many times as you like.  Please help.
             </div>
            <button className="donate-btn2" onClick={handleClick}>Donate points</button>
          </div>
            <div className="right-content">
            </div>
            
        </div>
    </div>
  )
}

export default Section2